import styled from 'styled-components';

/** How much of the old vDrive debt the plan has paid off so far. */
export const ProgressTrack = styled.div`
  height: 8px;
  border-radius: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.mediumGray};
`;

export const ProgressFill = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  border-radius: 8px;
  background: ${({ theme }) => theme.green};
  transition: ${({ theme }) => theme.transitions.ease200ms};
`;
